import { useState, type ReactNode } from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';

interface TooltipProps {
  title: string;
  children: ReactNode;
  placement?: 'top' | 'bottom';
}

export function Tooltip({ title, children, placement = 'bottom' }: TooltipProps) {
  const [visible, setVisible] = useState(false);
  const [size, setSize] = useState({ width: 0, height: 0 });

  if (Platform.OS !== 'web') return <>{children}</>;

  return (
    <View
      style={styles.wrapper}
      onLayout={(e) => setSize({ width: e.nativeEvent.layout.width, height: e.nativeEvent.layout.height })}
      // @ts-expect-error web mouse events
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && size.height > 0 && (
        <View
          pointerEvents="none"
          style={[
            styles.tooltipOuter,
            placement === 'bottom'
              ? { top: size.height + 6 }
              : { bottom: size.height + 6 },
          ]}
        >
          <View style={styles.tooltipBox}>
            <Text style={styles.tooltipText} numberOfLines={1}>{title}</Text>
          </View>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
  },
  tooltipOuter: {
    position: 'absolute',
    left: 0,
    right: 0,
    alignItems: 'center',
    zIndex: 9999,
  },
  tooltipBox: {
    backgroundColor: 'rgba(50, 50, 50, 0.92)',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 5,
    elevation: 4,
  },
  tooltipText: {
    color: '#ffffff',
    fontSize: 12,
  },
});
